import request from '@/utils/request'

const VUE_APP_BASIC_DATA_API = process.env.VUE_APP_BASIC_DATA_API
// const VUE_APP_BASIC_DATA_API = 'http://10.166.2.23:3000/mock/36/'

/**
* 获取图片验证码（B端）
*/
export function getGraphicToB(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}userEnterprise/auth/getGraphic?platformSource=H5`,
    method: 'get',
    data
  })
}

/**
* 获取短信验证码（B端）
*/
export function getSmsToB(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}userEnterprise/auth/getSms`,
    method: 'post',
    data
  })
}

/**
* 登录（B端）
*/
export function loginToB(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}userEnterprise/auth/login`,
    method: 'post',
    data
  })
}

// 厂商代理登录
export function loginBusiness() {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}userEnterprise/auth/loginWithToken`,
    method: 'get'
  })
}

// 获取三方登录集成的登录or登出地址
export function thirdAuthUrl(data) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}userEnterprise/auth/thirdAuthUrl`,
    method: 'get',
    params: data
  })
}




// WEBPACK FOOTER //
// ./src/api/loginToB.js